export { default as ConfigCard } from './ConfigCard';
export type { ConfigCardProps } from './ConfigCard';
